export enum EntityProfileEnum {
  ENTITY_SECTION_ABOUT = 'entity-about--text',
  ENTITY_TAB_TRIGGER = 'entity-tab--trigger',
  ENTITY_SHOW_MORE_BUTTON = 'entity-about--show-more-button',
  ENTITY_SHOW_MORE_COMMENTS_BUTTON = 'entity--show-more-comments-button',
  ENTITY_COUNT_RATING = 'entity--count-rating',
  ENTITY_COUNT_AVERAGE = 'entity--average-rating-on-card',
  ENTITY_RATING_CARD = 'entity--card',
  ENTITY_COMMENT_CONTENT = 'entity--comment-content',
  ENTITY_COMMENT_SESSION = 'entity-comment--section',
  ENTITY_COMMENT_STAR = 'comment-rating--entity-comment-start',
  ENTITY_COMMENT_DATE = 'comment-date--entity-comment',
  ENTITY_RATING_CONTAINER = 'entity--rating-container',
  ENTITY_COMMENT_TEXT = 'entity--comment-text-',
  ENTITY_TAB_ABOUT = 'entity--tab-about',
  ENTITY_TAB_RATING = 'entity--tab-rating',
  ENTITY_BUTTON_SHOW_MORE_COMMENT = 'entity--show-more-button',
  ENTITY_BAR_CONTAINER = 'entity-bar-container',
  ENTITY_BAR = 'entity-bar',
  ENTITY_SECTION_ICON = 'entity-section-icon',
  ENTITY_TAB_CONTAINER = 'entity-tab-container',
  ENTITY_TAB_CONTENT = 'entity-tab-content',
  ENTITY_SM_ACTION_HEADER = 'entity-sm-action--action-header',
  ENTITY_AVERAGE_RATING = 'entity--average-rating',
  ENTITY_FULL_COMMENT_COUNT = 'entity--full-comment-count',
  ENTITY_EMPTY_RATING = 'entity--empty-rating',
  ENTITY_RESPONSE_COMMENT_TEXT = 'response-comment-text--entity-comment',
}
